// 协议类型映射
export const agreementTypeMap = {
  '服务协议': '易云章服务协议.html',
  '隐私协议': '易云章隐私协议.html',
  '证书服务协议': '易云章证书服务协议.html',
}

// 获取协议内容的函数 - 返回完整的 HTML URL，使用 iframe 加载
export async function getAgreementHtml(title) {
  const fileName = agreementTypeMap[title]
  if (!fileName) {
    return ''
  }

  // 返回空字符串，让组件直接使用 iframe src 加载
  return ''
}

// 获取协议文件的 URL
export function getAgreementUrl(title) {
  const fileName = agreementTypeMap[title]
  if (!fileName) {
    return ''
  }
  return `/documents/${fileName}`
}

// 为了向后兼容，保留旧的导出结构
export const agreementHtml = {
  serviceAgreement: '',
  privacyPolicy: '',
  certificateServiceAgreement: '',
  enterpriseAndPersonalServiceAgreement: '',
}
